import { dialog } from "../../../../../nq-component";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import NavBar from "../../../../../components/navbar";
import UpcomingRequestFormPresenter from "./UpcomingRequestFormPresenter";
import DialogTable from "../../../../../components/DialogTable";
import ActionButtons from "./components/ActionButtons";
import UpcomingRequestTable from "./components/UpcomingRequestTable";
import CardDetails from "./components/CardDetails";
import DialogModal from "../../../../../components/Dialog";

class UpcomingRequestFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false, selectedRawIds: [] };
    this.presenter = new UpcomingRequestFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "stock_requests";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  async onSubmitForm(e) {
    e.preventDefault();
    const params = this.getParams();
    console.log("pp", params);
    switch (params.approve) {
      case "reconciliation":
        this.approveReco();
        break;
      default:
        this.presenter.onSubmitForm();
        break;
    }
  }

  approveReco() {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Approve Request"
          message="Are you sure want to approve this request?"
          isCancelButton={true}
          onSubmit={() => this.presenter.approveReco()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
    // this.presenter.approveReco();
  }

  handleOpenRaw() {
    const schema = this.getSchema("raw_materials");

    dialog.fire({
      html: (
        <DialogTable
          title="raw_materials"
          where={{}}
          schema={schema}
          onCancel={() => dialog.close()}
          onSelect={(selectedItems) => {
            this.setState((prev) => {
              const existing = prev.object.raw_materials || [];

              console.log("exxx", existing);

              const mergedMap = new Map();
              for (const item of existing) {
                mergedMap.set(item.id, item);
              }

              for (const item of selectedItems) {
                const existingItem = mergedMap.get(item.id);
                mergedMap.set(item.id, {
                  ...item,
                  quantity: existingItem?.quantity || item.quantity || "",
                });
              }

              return {
                object: {
                  ...prev.object,
                  raw_materials: Array.from(mergedMap.values()),
                },
              };
            });
          }}
        />
      ),
      footer: false,
    });
  }

  handleDeleteSelected() {
    const { selectedRawIds, object } = this.state;
    const updated = (object.raw_materials || []).filter(
      (item) => !selectedRawIds.includes(item.id),
    );

    this.setState({
      object: {
        ...object,
        raw_materials: updated,
      },
      selectedRawIds: [],
    });
  }

  onChange(value, field) {
    if (field === "remarks") {
      const hasValue = value !== undefined && value !== null && value !== "";
      this.setState({ hasRemarks: hasValue });
    }

    this.presenter.onChange(value, field);
  }

  handleSelectAll = (e) => {
    const checked = e.target.checked;
    const allIds = (this.state.object.raw_materials || []).map(
      (item) => item.id,
    );
    this.setState({
      selectedRawIds: checked ? allIds : [],
    });
  };

  handleSelectOne = (e, id) => {
    const { selectedRawIds } = this.state;
    const updated = e.target.checked
      ? [...selectedRawIds, id]
      : selectedRawIds.filter((itemId) => itemId !== id);
    this.setState({ selectedRawIds: updated });
  };

  handleChangeQuantity = (e, index) => {
    const value = e.target.value;
    const updatedMaterials = [...(this.state.object.raw_materials || [])];
    updatedMaterials[index] = {
      ...updatedMaterials[index],
      quantity: value,
      quantityApprove: value,
    };

    this.setState((prev) => ({
      object: {
        ...prev.object,
        raw_materials: updatedMaterials,
      },
    }));
  };

  handleChangeQuantity2 = (e, index) => {
    const value = e.target.value;
    const updatedMaterials = [...(this.state.object.items || [])];
    updatedMaterials[index] = {
      ...updatedMaterials[index],

      quantityApprove: value,
    };

    this.setState((prev) => ({
      object: {
        ...prev.object,
        items: updatedMaterials,
      },
    }));
  };

  render() {
    const object = this.state.object;
    const params = this.getParams();

    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "View Request";
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h2
                  className="fw-bold mt-3 text-capitalize"
                  style={{ color: "#82c14a" }}
                >
                  <i
                    onClick={() => this.navigateBack()}
                    className="bi bi-chevron-compact-left"
                    style={{ color: "black", cursor: "pointer" }}
                  ></i>
                  {label}
                </h2>

                {object?.id && (
                  <span
                    className="px-3 py-1 fw-semibold"
                    style={{
                      backgroundColor: "#ffcd29",
                      borderRadius: "999px",
                      color: "#212529",
                      fontSize: "0.875rem",
                      border: "1px solid #d6a500",
                    }}
                  >
                    {object?.status}
                  </span>
                )}
              </div>

              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                <CardDetails object={object} />

                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <UpcomingRequestTable
                    object={object}
                    params={params}
                    selectedIds={this.state.selectedRawIds}
                    onSelectAll={this.handleSelectAll}
                    onSelectOne={this.handleSelectOne}
                    onChange={this.handleChangeQuantity}
                    onChange2={this.handleChangeQuantity2}
                    onAdd={() => this.handleOpenRaw()}
                    onDelete={() => this.handleDeleteSelected()}
                    disableAdd={true}
                    hasQuantity={false}
                    showUOM={false}
                    disableQty={true}
                    checkbox={object?.id ? false : true}
                    showQuantityApprove={params?.approve ? true : false}
                    disableQtyApprove={false}
                    hasRemarks={this.state.hasRemarks}
                    getObjectId={this.getObjectId()}
                    showAddButton={false}
                  />

                  <ActionButtons
                    params={params}
                    approveReco={this.approveReco.bind(this)}
                    onClickBack={this.onClickBack.bind(this)}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(UpcomingRequestFormPage);
